module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Electric/Mixer-0a580e1bd0093e73a4c231272ab36ebc.svg";